// const cache = new Map();

// export const setCache = (key, value, ttl) => {
//     const expireTime = Date.now() + ttl * 1000; // TTL in milliseconds
//     cache.set(key, { value, expireTime });
//     console.log(`[CACHE SET] Key: ${key}, Expire At: ${new Date(expireTime).toISOString()}`);

//     // Automatically remove expired entries
//     setTimeout(() => cache.delete(key), ttl * 1000);
// };

// export const getCache = (key) => {
//     const cached = cache.get(key);
//     if (!cached) return null;

//     // Check if the cached data is expired
//     if (Date.now() > cached.expireTime) {
//         cache.delete(key);
//         return null;
//     }

//     return cached.value;
// };

// export const clearCache = (key) => {
//     cache.delete(key);
// };

export const setCache = (key, value, ttl = 10) => {
    const expireTime = Date.now() + ttl * 1000;
    const cacheData = { value, expireTime };
    localStorage.setItem(key, JSON.stringify(cacheData));
    console.log(`[CACHE SET] Key: ${key}, Data: ${JSON.stringify(value)}, Expires At: ${new Date(expireTime).toISOString()}`);

    // Schedule removal of the cache after TTL
    setTimeout(() => {
        if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
            console.log(`[CACHE REMOVED] Key: ${key} after ${ttl} seconds`);
        }
    }, ttl * 1000);
};

export const getCache = (key) => {
    const cached = localStorage.getItem(key);
    if (!cached) {
        console.log(`[CACHE MISS] Key: ${key}`);
        return null;
    }

    const { value, expireTime } = JSON.parse(cached);
    if (Date.now() > expireTime) {
        console.log(`[CACHE EXPIRED] Key: ${key}`);
        localStorage.removeItem(key);
        return null;
    }

    console.log(`[CACHE HIT] Key: ${key}, Data: ${JSON.stringify(value)}`);
    return value;
};